import { bus } from './index'
(function flexible (window, document) {
  var docEl = document.documentElement
  var dpr = window.devicePixelRatio || 1

  // adjust body font size
  function setBodyFontSize () {
    if (document.body) {
      document.body.style.fontSize = (12 * dpr) + 'px'
    }
    else {
      document.addEventListener('DOMContentLoaded', setBodyFontSize)
    }
  }
  setBodyFontSize();

  // 1336 / 750
  function setRemUnit () {
    if(['input'].includes(document.activeElement.tagName.toLocaleLowerCase())){
      //因为键盘弹起而触发的resize不处理
      return;
    }

    // var rem = docEl.clientWidth / 13.34 // 1334px
    // docEl.style.fontSize = rem + 'px'

    var screenWidth = docEl.clientWidth
    var screenHeight = docEl.clientHeight
    var width = screenWidth, height = screenHeight
    if(screenWidth / screenHeight > 1334 / 750){ // 宽度比较长，用高度做标准
      height = screenHeight
      width = screenHeight * 1334 / 750
    }else{
      width = screenWidth
      height = screenWidth * 750 / 1336
    }
    var rem = width / 13.34
    docEl.style.fontSize = rem + 'px'
    bus.$emit('setRemUnit')
  }

  setRemUnit()

  // reset rem unit on page resize
  window.addEventListener('resize', setRemUnit)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      setRemUnit()
    }
  })

  // detect 0.5px supports
  if (dpr >= 2) {
    var fakeBody = document.createElement('body')
    var testElement = document.createElement('div')
    testElement.style.border = '.5px solid transparent'
    fakeBody.appendChild(testElement)
    docEl.appendChild(fakeBody)
    if (testElement.offsetHeight === 1) {
      docEl.classList.add('hairlines')
    }
    docEl.removeChild(fakeBody)
  }
}(window, document));
